export default __webpack_public_path__ + "app/components/tables/intradays/reactIntradaysMainTable.html";